import { useNavigate } from 'react-router-dom';
import ForgotPasswordForm from '../components/ForgotPasswordForm';

/**
 * 独立找回密码页（/forgot-password）
 *
 * 复用 ForgotPasswordForm 组件，承担"邮箱 → 发送重置链接"这一步。
 * 点击重置链接会跳到 /reset-password/:token 完成新密码设置。
 */
export default function ForgotPasswordPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 px-4 py-10">
      <div className="w-full max-w-[420px] bg-white rounded-2xl shadow-xl px-8 pt-8 pb-8">
        <div className="text-center mb-6">
          <div className="w-14 h-14 bg-teal-50 rounded-full flex items-center justify-center mx-auto mb-3">
            <i className="ri-lock-unlock-line text-teal-500 text-2xl"></i>
          </div>
          <h2 className="text-lg font-bold text-slate-800">找回密码</h2>
          <p className="text-slate-500 mt-1 text-sm">通过邮箱接收重置链接</p>
        </div>
        <ForgotPasswordForm onBack={() => navigate('/login')} />
      </div>
    </div>
  );
}
